import { render, staticRenderFns } from "./leftTreeRightTable.vue?vue&type=template&id=25af13fa&scoped=true&"
import script from "./leftTreeRightTable.vue?vue&type=script&lang=js&"
export * from "./leftTreeRightTable.vue?vue&type=script&lang=js&"
import style0 from "./leftTreeRightTable.vue?vue&type=style&index=0&id=25af13fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af13fa",
  null
  
)

export default component.exports